import { defineApi } from '#/api/define-api'
import { requestClient } from '#/api/request'

export interface CreateAdAccountParams {
  accountId: string
  accountName: string
  mediaPlatform: string
  mediaUserName: string
  mediaUserId: string
  storeDomain?: string
  firstCategory: string
}

export interface GetAdAccountBasicParams {
  accountId: string
  mediaPlatform: string
}

export interface AdAccountBasicInfo {
  accountId: string
  accountName: string
  mediaPlatform: string
  mediaUserId: string
  mediaUserName: string
}

export interface AdAccountsBasicListParams {
  pageIndex?: number
  pageSize?: number
  accountId?: string
  mediaPlatform?: string
}

export interface AdAccountsBasicListItem {
  accountId: string
  accountName: string
  mediaPlatform: string
  mediaUserId: string
  mediaUserName: string
}

export interface GetAdAccountsParams {
  firstCategory?: string
  mediaPlatform?: string
  accountId?: string
  pageIndex?: number
  pageSize?: number
}

export interface DeleteAdAccountParams {
  accountId: string
  mediaPlatform?: string
}

export interface ResyncAdAccountParams {
  accountId: string
  mediaPlatform: string
}

export interface AdAccountsListItem {
  userId?: number
  userName?: string
  accountId?: string
  accountName?: string
  mediaPlatform?: string
  mediaUserId?: string
  mediaUserName?: string
  storeDomain?: string
  firstCategory?: string
  syncStatus?: string
  updatedTime?: string
}

export interface GetAdAccountsResponse {
  list?: AdAccountsListItem[]
  total?: number
  pageIndex?: number
  pageSize?: number
}

export const materialAnalysisAdAccountsApi = defineApi(
  'operation',
  ({ prefix }) => {
    function getAdAccountBasic(params: GetAdAccountBasicParams) {
      return requestClient.get<AdAccountBasicInfo>(
        prefix('materials/ad-accounts-basic'),
        {
          params,
        },
      )
    }

    function createAdAccount(params: CreateAdAccountParams) {
      return requestClient.post(prefix('materials/ad-accounts'), params)
    }

    function getAdAccountBasicList(params: AdAccountsBasicListParams) {
      return requestClient
        .get<{
          list?: AdAccountsBasicListItem[]
          total?: number
          pageIndex?: number
          pageSize?: number
        }>(prefix('materials/ad-accounts-basic-list'), {
          params,
        })
        .then((res) => {
          return {
            items: res?.list || [],
            total: Number(res?.total || 0),
            pageIndex: Number(res?.pageIndex || params.pageIndex || 1),
            pageSize: Number(res?.pageSize || params.pageSize || 20),
          }
        })
    }

    function getAdAccounts(params: GetAdAccountsParams) {
      return requestClient.get<GetAdAccountsResponse>(
        prefix('materials/ad-accounts'),
        {
          params,
        },
      )
    }

    function deleteAdAccount(params: DeleteAdAccountParams) {
      return requestClient.delete(prefix('materials/ad-accounts'), {
        params,
      })
    }

    function resyncAdAccount(params: ResyncAdAccountParams) {
      return requestClient.post(prefix('materials/ad-accounts/resync'), params)
    }

    return {
      getAdAccountBasic,
      getAdAccountBasicList,
      getAdAccounts,
      createAdAccount,
      deleteAdAccount,
      resyncAdAccount,
    }
  },
)
